import { logger } from "@moodys/mdc-frontend.services.logger";

import { AlertBannerContent, AlertBannerSeverity } from "./alertBanner.types";

const ALERT_SEVERITIES: string[] = Object.values(AlertBannerSeverity);
const DEFAULT_SEVERITY = "info";

export const getAlertSeverity = (severity: AlertBannerContent["severity"]) => {
  const trimmedSeverity = severity?.trim();
  if (!trimmedSeverity) {
    return DEFAULT_SEVERITY;
  }
  if (!ALERT_SEVERITIES.includes(trimmedSeverity)) {
    logger.warn({
      message: `Alert Banner AEM JSON has invalid severity value: ${severity}. Defaulting to "info"`,
    });
    return DEFAULT_SEVERITY;
  }
  return severity;
};
